import { PoolSimulatorTool } from "./PoolSimTool";

export const PoolSimulatorWrapper = () => {
  return (
    <main className="w-full flex h-fit  flex-col px-5 md:px-10 py-10 relative">
      <h2 className="text-[22px] text-neutral-200 font-semibold uppercase">
        Pool Simulator
      </h2>
      <PoolSimulatorTool />
    </main>
  );
};
